import React from "react";
import classNames from "classnames";
import getClassNameFactory from "../../utilities/classNames";
import { SocialShareTypes } from "./SocialShareTypes";

var getHref = function getHref(_ref) {
  var type = _ref.type,
      pageTitle = _ref.pageTitle,
      pageUrl = _ref.pageUrl;
  var EMAIL = SocialShareTypes.EMAIL,
      FACEBOOK = SocialShareTypes.FACEBOOK,
      LINE = SocialShareTypes.LINE,
      LINKEDIN = SocialShareTypes.LINKEDIN,
      PRINT = SocialShareTypes.PRINT,
      TWITTER = SocialShareTypes.TWITTER,
      WHATSAPP = SocialShareTypes.WHATSAPP,
      MIXI = SocialShareTypes.MIXI,
      WEIBO = SocialShareTypes.WEIBO;

  switch (type) {
    case EMAIL:
      return "mailto:?subject=".concat(pageTitle, "&body=").concat(pageUrl);

    case FACEBOOK:
      return "https://www.facebook.com/sharer/sharer.php?u=".concat(pageUrl);

    case LINE:
      return "https://lineit.line.me/share/ui?url=".concat(pageUrl);

    case LINKEDIN:
      return "https://www.linkedin.com/shareArticle?mini=true&url=".concat(pageUrl, "&title=").concat(pageTitle);

    case MIXI:
      return "https://mixi.jp/share.pl?u=".concat(pageUrl);

    case PRINT:
      return "javascript:window.print()";
    // eslint-disable-line no-script-url

    case TWITTER:
      return "https://twitter.com/intent/tweet?url=".concat(pageUrl, "&text=").concat(pageTitle);

    case WEIBO:
      return "http://service.weibo.com/share/share.php?url=".concat(pageUrl, "&title=").concat(pageTitle);

    case WHATSAPP:
      return "whatsapp://send?text=".concat(pageUrl);

    default:
      return "";
  }
};

var SocialShare = function SocialShare(props) {
  var getClassName = getClassNameFactory(SocialShare.displayName);
  var href = getHref(props);
  return /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      modifiers: classNames(props.type)
    })
  }, /*#__PURE__*/React.createElement("a", {
    href: href
  }, props.children));
};

SocialShare.displayName = "SocialShare";
SocialShare.types = SocialShareTypes;
export default SocialShare;